import { render, staticRenderFns } from "./StockProductManualFormEmbeddable.vue?vue&type=template&id=281c1394&"
import script from "./StockProductManualFormEmbeddable.vue?vue&type=script&lang=js&"
export * from "./StockProductManualFormEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports